import {
  ProductTabsBtnID,
  EProductTabsLinkHash,
  ProductRecommendType,
  TrackingHomeTabsBtnID,
  ProductTrendType,
  UnitsSoldTrendBtnID,
  ActionMenuHash,
  TrackingPersonHashBtnID,
  TrackingLoginType,
  TrackingEventID,
} from "../enums";

export const TrackHomeTabs: Record<
  ProductRecommendType,
  TrackingHomeTabsBtnID
> = {
  [ProductRecommendType.All]: TrackingHomeTabsBtnID.All,
  [ProductRecommendType.Bestselling]: TrackingHomeTabsBtnID.Bestselling,
  [ProductRecommendType.HighCos]: TrackingHomeTabsBtnID.HighCos,
};

export const TrackProductTabs: Record<EProductTabsLinkHash, ProductTabsBtnID> =
  {
    [EProductTabsLinkHash.Overview]: ProductTabsBtnID.Overview,
    [EProductTabsLinkHash.Trend]: ProductTabsBtnID.Trend,
    [EProductTabsLinkHash.Creators]: ProductTabsBtnID.Creators,
    [EProductTabsLinkHash.Videos]: ProductTabsBtnID.Videos,
    [EProductTabsLinkHash.Lives]: ProductTabsBtnID.Lives,
  };

export const TrackTrendBtnID: Record<ProductTrendType, UnitsSoldTrendBtnID> = {
  [ProductTrendType.Last7Days]: UnitsSoldTrendBtnID.Last7Days,
  [ProductTrendType.Last28Days]: UnitsSoldTrendBtnID.Last28Days,
};

export const TrackPersonHashBtnID: Record<
  ActionMenuHash,
  TrackingPersonHashBtnID
> = {
  [ActionMenuHash.MyAccount]: TrackingPersonHashBtnID.MyAccount,
  [ActionMenuHash.MyShowcase]: TrackingPersonHashBtnID.MyShowcase,
  [ActionMenuHash.SampleProcess]: TrackingPersonHashBtnID.SampleProcess,
  [ActionMenuHash.DallasTickets]: TrackingPersonHashBtnID.DallasTickets,
  [ActionMenuHash.LaTickets]: TrackingPersonHashBtnID.LaTickets,
};
export const TrackLoginEventMap: Record<TrackingLoginType, TrackingEventID> = {
  [TrackingLoginType.FirstLogin]: TrackingEventID.FirstRegistrationLogin,
  [TrackingLoginType.Login]: TrackingEventID.LoginSuccess,
};

export const UtmList = [
  "utm_source",
  "utm_content",
  "utm_term",
  "utm_medium",
  "utm_campaign",
];
